import React, { useMemo } from 'react'
import { assignAndRemoveTagExecutionData } from '../../../../../models/axiosModel';
import globalStyles from "../../../../../assets/styles/global.module.scss";
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss"
import { Divider, Grid, Typography } from '@mui/material';
import { ACTION_TYPE_NAME } from '../../../../../components/dashboard/flowBuilder/flowBuilderConstants';
import { getValueOrDefault } from '../../../../../utils/constants';

interface AssignAndRemoveTagActionProps {
    actionData: assignAndRemoveTagExecutionData,
    actionType: string,
} 

const AssignAndRemoveTagAction: React.FC<AssignAndRemoveTagActionProps> = (props) => {
    
    const { actionData, actionType } = props;
    
    const getActionTypeName = useMemo(() => {
        if(actionType == ACTION_TYPE_NAME['ASSIGN_TAG']){
            return "Assign Tag";
        }
        return "Remove Tag";
    }, [actionType])

    return (
        <>
            <Grid container className={`${styles.saveVariableActionMainContainer} ${globalStyles.flexColumn}`} gap={1}>
                <Grid item className={globalStyles.fullwidth}>
                    <Typography className={styles.customAPICallMsgTitle}>
                        {getActionTypeName}
                    </Typography>
                </Grid>
                <Divider />
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container gap={"4px"} flexWrap={"nowrap"} alignItems={"center"}>
                        <Grid item xs={6} className={styles.customAPICallInfoTitle}>
                            Tag Name  
                        </Grid> 
                        <Grid item xs={5.5}>
                            {getValueOrDefault(actionData?.ticket_tag_name)}
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </>
    )
}

export default AssignAndRemoveTagAction
